import { useTranscriptionsState } from '@modules/transcriptions/useTranscriptionsState';
import { useMemo } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { RTCControls } from 'src/features/RTCBar/RTCControls/RTCControls';
import { useTranscriptionControl } from 'src/hooks/useTranscriptionControl';
import { useVoiceChannelContext } from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';

export const VoiceChannelControls = () => {
  const { user } = useAuthContext();
  const {
    disconnectVoiceChannel,
    setMuted,
    setDeafed,
    startScreenShare,
    stopScreenShare,
    startCamera,
    stopCamera,
  } = useVoiceChannelContext();

  const { room, activeVoiceChannel, localParticipant } = useLivekitRTCState();

  const { activeTranscriptionChannelId, activeTranscriptionOwner } =
    useTranscriptionsState();

  const { handleStopTranscription } = useTranscriptionControl();

  const isConnected = useMemo(
    () => !!activeVoiceChannel?.channel?._id,
    [activeVoiceChannel?.channel?._id],
  );

  return (
    <RTCControls
      room={room!}
      isConnected={isConnected}
      type={activeVoiceChannel.channel.p2p ? 'p2p' : 'voice'}
      muted={localParticipant.muted}
      deafed={localParticipant.deaf}
      sharing={localParticipant.sharing}
      video={localParticipant.camera}
      disconnect={disconnectVoiceChannel}
      mute={setMuted}
      deaf={setDeafed}
      startScreenShare={startScreenShare}
      stopScreenShare={stopScreenShare}
      startCamera={startCamera}
      stopCamera={stopCamera}
      showStopTranscription={
        activeTranscriptionChannelId === activeVoiceChannel?.channel?._id &&
        activeTranscriptionOwner === user?._id
      }
      stopTranscription={handleStopTranscription}
    />
  );
};
